import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/driving-license",
        component: List,
        name: "driving-license-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/driving-license/:id/edit",
        component: Edit,
        name: "driving-license-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/driving-license/create",
        component: Create,
        name: "driving-license-create",
        meta: {
            requiresAuth: true,
        },
    },
];
